// src/pages/project/settings/ProjectWbsGroupsPage.tsx
import React from 'react';

type WbsGroupRow = {
  id: string;
  name: string;
  responsibleCompanyName: string;
  nodeCount: number;
};

const mockWbsGroups: WbsGroupRow[] = [
  // TODO: API 연동
];

const ProjectWbsGroupsPage: React.FC = () => {
  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-800">WBS Groups</h3>
        <button className="rounded-lg bg-sky-700 text-white px-3 py-1.5 text-xs hover:bg-sky-800">
          + 새 WBS Group
        </button>
      </div>

      <table className="min-w-full text-sm">
        <thead className="bg-gray-50 text-xs text-gray-500">
          <tr>
            <th className="px-3 py-2 text-left">Group Name</th>
            <th className="px-3 py-2 text-left">Responsible Company</th>
            <th className="px-3 py-2 text-right">Nodes</th>
            <th className="px-3 py-2 text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {mockWbsGroups.length === 0 && (
            <tr>
              <td colSpan={4} className="px-3 py-6 text-center text-gray-500">
                등록된 WBS Group이 없습니다.
              </td>
            </tr>
          )}

          {mockWbsGroups.map((g) => (
            <tr key={g.id} className="border-t">
              <td className="px-3 py-2">{g.name}</td>
              <td className="px-3 py-2 text-xs text-gray-700">
                {g.responsibleCompanyName}
              </td>
              <td className="px-3 py-2 text-right text-xs text-gray-600">
                {g.nodeCount}
              </td>
              <td className="px-3 py-2 text-right space-x-2">
                <button className="text-xs text-sky-700 hover:underline">
                  노드 매핑
                </button>
                <button className="text-xs text-gray-600 hover:underline">
                  수정
                </button>
                <button className="text-xs text-rose-600 hover:underline">
                  삭제
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectWbsGroupsPage;
